<template>
  <div id="defaultId1">
    <div class="pb20">
      <div class="flex_center_between_box">
        <div
          class="left_menu left_menu_padding"
          :class="$store.state.app.isMenu ? '' : 'hidemenu'"
        >
          <div class="FilterQuestion">
            <div class="left_menu_question">
              <div class="table">
                <div class="left_menu_context">
                  <p class="left_menu_context-title">
                    Sanctions Type
                    <span class="Clear_all" @click="clearAllTags"
                      ><i
                        class="iconfont icon-qingchu"
                        style="color: #ff6a6a; margin-right: 5px"
                      ></i
                      >Clear All</span
                    >
                  </p>

                  <el-select
                    filterable
                    v-model="sanctionTypevalue"
                    clearable
                    :popper-append-to-body="false"
                    @change="selectChange"
                    style="width: 100%"
                    placeholder="Select Sanctions Type"
                  >
                    <el-option
                      v-for="item in sanctionTypeList"
                      :key="item.value"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="left_menu_context">
                  <p class="left_menu_context-title">
                    Sanctioned Country/Region
                  </p>

                  <el-select
                    :popper-append-to-body="false"
                    filterable
                    v-model="countryOfDesvalue"
                    clearable
                    @change="selectChange"
                    style="width: 100%"
                    placeholder="Sanctioned Country/Region"
                  >
                    <el-option
                      v-for="item in countryOfDesList"
                      :key="item.value"
                      :label="item.countryName"
                      :value="item.countryCode"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="cc5f49"
          :class="
            $store.state.app.isMenu
              ? 'scrollbar scrollbar_right'
              : ' scrollbar scrollbar_right udb507two'
          "
        >
          <div class="right_cont_box company_box">
            <div class="table-index">
              <h2 class="operations-head-content">
                <span class="operations-head"
                  >List of Product Chain Sanctions
                </span>
                <span
                  class=" moreSaction textdecoration"
                  style="
                    color: #009ea7;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                  "
                  @click="gotoSaction('/sanction/index?selectCode=3')"
                  >Search more sanction on other companies</span
                >
              </h2>
              <div class="operations-box-bottom table_X">
                <el-table
                  :data="ImporttableData"
                  style="width: 100%"
                  height="850"
                  v-loading="loading"
                  :key="key"
                  empty-text="No Data"
                >
                  <el-table-column
                    prop="ie_date"
                    width="100"
                    label=" HS-Code "
                    show-overflow-tooltip
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span class="table-content">{{ scope.row.hsCode }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="productName"
                    width="150"
                    label="Product Name"
                    show-overflow-tooltip
                  >
                  </el-table-column>

                  <el-table-column
                    prop="sanctionType"
                    width="550"
                    label="Sanctions Type"
                    show-overflow-tooltip
                  >
                  </el-table-column>

                  <el-table-column
                    prop="Amount"
                    label="Sanctioned Country/Region"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span
                        v-for="(value, inde) in scope.row?.countryCodeNameList"
                        :key="inde"
                      >
                        <el-popover
                          placement="top"
                          trigger="hover"
                          popper-class="table_popover"
                          :content="value?.countryName"
                        >
                          <img
                            class="contry_img"
                            slot="reference"
                            :src="value.flag"
                          />
                        </el-popover>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>

  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import { getbusinessActivitiesDetails } from "@/api/companyApi";
import rectcard from "../../../../components/rectCard/index.vue";
import content_text from "../../../../components/text_content/index.vue";
import gui_card from "../../../../components/gui_card/gui_card.vue";
import { mixins1 } from "@/mixins/index";
import ReLogin from "../../../../components/ReLogin.vue";
import {
  tradeForProductNew,
  getProductChainSanctionsFilter,
} from "@/api/companyApi.js";
// import { searchTradeHscode, searchFilterConditions } from "@/api/searchApi.js";
//importEnd

export default {
  name: "",
  mixins: [mixins1],
  props: {},

  components: {
    gui_card,
    rectcard,
    content_text,

    ReLogin,
  },
  computed: {},
  created() {},
  mounted() {
    this.$emit("UpdatamarkTotalList", false);
    this.$store.dispatch("app/setTools", {
      name: "select",
      key: "isActive",
      value: false,
    });
    this.getCompanyList();
    this.getsearchFilterConditions();
  },
  data() {
    return {
      reLoginVis: false,
      key: 0,
      Related: false,
      parentTablelist: [],
      imexportsDialog: false,
      companyList: [],
      value: {},
      maxCharacters: 200,
      imexportsDialog: false,
      content: [],
      exportLoding: false,
      loading: true,
      page: {
        pageSize: 10,
        page: 1,
        total: 0,
      },
      ImporttableData: [],
      countryOfDesList: [],
      countryOfDesvalue: "",

      hsCodeList: [],
      hsCodevalue: "",
      productList: [],

      productvalue: "",
      sanctionTypeList: [],
      sanctionTypevalue: "",
      // srcviewscompanydetailsBackgroundSnapshotvueDataEnd
    };
  },
  computed: {},
  methods: {
    gotoSaction(path) {
      let routeData = this.$router.resolve({
        path: "/sanction/productList",
        query: {
          keyword: sessionStorage.getItem("hsCodeDescription"),
          selectCode: 3,
        },
      });

      window.open(routeData.href, "_blank");
    },

    clearAllTags() {
      this.sanctionTypevalue = "";
      this.countryOfDesvalue = "";
      this.selectChange();
    },
    selectChange() {
      this.getCompanyList();
      this.getsearchFilterConditions();
    },

    getCompanyList() {
      this.loading = true;
      tradeForProductNew({
        // hsCode: this.$route.query.id3a,
        hsCode: this.$route.query.id3a,
        sanctionsType: this.sanctionTypevalue,
        countryCode: this.countryOfDesvalue,
      }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          let parentTable = res.data.rows;
          this.page.total = res.data.total;
          parentTable.map((item, index) => {
            if (item.countryCodeNameList) {
              item.countryCodeNameList.map((ite, index) => {
                let countryImg = this.getCountryImgUrl(ite.countryCode);
                if (countryImg) {
                  let flag = require("../../../../../static" + countryImg);
                  ite.flag = flag;
                }
              });
            }
          });
          this.ImporttableData = parentTable;
        } else {
          this.ImporttableData = [];
          this.page.total = 0;
        }
      });
    },
    getsearchFilterConditions() {
      getProductChainSanctionsFilter({
        //    hsCode: this.$route.query.id3a,
        hsCode: this.$route.query.id3a,
        sanctionsType: this.sanctionTypevalue,
        countryCode: this.countryOfDesvalue,
      }).then((res) => {
        if (res.code == 200) {
          this.countryOfDesList = res.data.countryCodeNameList;
          this.sanctionTypeList = res.data.sanctionType;
        }
      });
    },
    //    pdf下载
    exportDetail() {
      const element = document.getElementById("exportDetail");
      const options = {
        filename: "exportDetail.pdf",
        image: { type: "jpeg", quality: 1 },
        // html2canvas: { scale:1 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      html2pdf().from(element).set(options).save();
      // html2pdf().from(element).save();
    },
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },

    // 获取数据

    default() {},
    // srcviewscompanydetailsBackgroundSnapshotvueMethodEnd
  },
};
</script>
<style scoped>
.uPdtqFl {
  padding-right: 2.857142857142857rem;
  padding-top: 2.142857142857143rem;
  padding-left: 2.857142857142857rem;
  padding-bottom: 2.142857142857143rem;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-top-left-radius: 0.2857142857142857rem;
  border-bottom-left-radius: 0.2857142857142857rem;
  border-top-right-radius: 0.2857142857142857rem;
  border-bottom-right-radius: 0.2857142857142857rem;
}

.importDetail-head {
  display: flex;
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.contclass {
  font-size: 1.4285714285714286rem;
  color: #238acc;
  font-weight: normal;
  font-style: normal;
  cursor: pointer;
}

.ViewMore {
  line-height: 1.8571428571428572rem;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  margin-left: 2.142857142857143rem;
}

.uc1096 {
  height: 100%;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-left {
  display: flex;
  font-size: 1.1428571428571428rem;
  font-family: "Arial Bold";
  font-weight: normal;
  color: #022955;
  padding-left: 1.4285714285714286rem;
  background-color: #f2f5f9;
}

.footer {
  padding-left: 0rem;
  overflow: hidden;
}

.ecahrts-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.07142857142857142rem solid #cccccc;
}

.title-left {
  display: flex;
  align-items: center;
  padding-bottom: 0.9285714285714286rem;
  padding-top: 0.9285714285714286rem;
}

.td {
  margin: 1.0714285714285714rem 0 0 1.7857142857142858rem;
}

.relate-left {
  height: 4.142857142857143rem;
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  line-height: 4.142857142857143rem;
  text-align: left;
  font-family: "Arial Bold";
}

.relate-Financial {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
}

.computer_right_cont_box {
  margin-top: 1.4285714285714286rem;
}
.tablewieth {
  width: 70%;
}

.aaa {
  font-size: 0.7142857142857143rem;
  color: #fa6666;
  position: absolute;
  left: 2.142857142857143rem;
  top: 14.285714285714286rem;
}

.bbb {
  font-size: 0.7142857142857143rem;
  color: #fa755c;
  position: absolute;
  left: 2.5rem;
  top: 6.071428571428571rem;
}

.ccc {
  font-size: 0.7142857142857143rem;
  color: #fc9249;
  position: absolute;
  left: 7.5rem;
  top: 0.5714285714285714rem;
}

.ddd {
  font-size: 0.7142857142857143rem;
  color: #ffd81a;
  position: absolute;
  left: 23.214285714285715rem;
  top: 0.5714285714285714rem;
}

.fff {
  font-size: 0.7142857142857143rem;
  color: #aec918;
  position: absolute;
  width: 3.642857142857143rem !important;
  height: 2.142857142857143rem;
  top: 6.071428571428571rem;
  left: 30rem;
}

.ggg {
  font-size: 0.7142857142857143rem;
  color: #63b819;
  position: absolute;
  left: 28.928571428571427rem;

  top: 14.285714285714286rem;
}

.hhh {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  position: absolute;
  left: 13.428571428571429rem;
  top: 14.285714285714286rem;
}

.echarts {
  width: 30.714285714285715rem;
  height: 17.857142857142858rem;
  padding-left: 3.2857142857142856rem;
}

.table_box {
  position: relative;
}

.echarts-content {
  margin-top: 2.857142857142857rem;
  padding: 0 4.285714285714286rem;
}

.echarts-item {
  display: flex;
  justify-content: flex-start;
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  line-height: 1.6428571428571428rem;
  margin-bottom: 2.142857142857143rem;
}

.echarts-item-left {
  display: inline-block;
  width: 15.714285714285714rem;
  margin-right: 1.4285714285714286rem;
  font-family: "Arial Bold";
}

.ecahrtstutwo {
  position: relative;
  left: 1.4285714285714286rem;
}

.uUIRzUi {
  padding: 2.142857142857143rem 2.857142857142857rem;
}

.left_box {
  width: 91%;
}

.right_box {
  width: 40%;
  background-color: #fff;
}

.operations-box-bottom /deep/ .el-table .cell {
  line-height: 32px;
  height: 40px;
}

/* 贸易关单 */
.table_oper1 {
  display: inline-block;
  width: 26px;
  height: 26px;
  line-height: 27px;
}

.ant-modal-body {
  padding: 24px;
  font-size: 1rem;
  color: #1a2332;
  line-height: 1.5;
  word-wrap: break-word;
}

.trade-details-field {
  border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
}

.trade-details-modal table {
  width: 100%;
  margin-bottom: 18px;
  font-size: 1rem;
}

.trade-details-modal table,
.trade-details-modal td,
.trade-details-modal th {
  padding: 0.55rem;
  border-collapse: collapse;
  word-break: keep-all;
  text-align: right;
}

.trade-details-modal table thead {
  background: #009ea7;
  color: #fff;
}

.trade-details-modal table thead tr > th {
  font-weight: 700;
  padding-left: 12px;
  text-align: left;
}

.trade-details-modal th {
  padding: 0.55rem;
}

.button-list-in-trade-detail {
  display: inline-block;
}

.button-list-in-trade-detail .row-content {
  display: inline-block;
  padding-right: 40px;
  vertical-align: top;
}

.button-list-in-trade-detail .link-button {
  display: inline-block;
  padding: 0 9px;
  color: #177dff;
  cursor: pointer;
  border-radius: 2px;
  transition: all 0.25s;
}

.trade-details-modal table tbody tr > td {
  color: rgba(0, 0, 0, 0.65);
  padding-left: 12px;
  text-align: left;
  line-height: 25px;
}

.trade-details-modal td {
  padding: 0.55rem;
}

.button-list-in-trade-detail .ant-divider-vertical {
  margin: 0 3px;
}

.ant-divider,
.ant-divider-vertical {
  position: relative;
  top: -0.06em;
  display: inline-block;
  width: 1px;
  height: 0.9em;
  margin: 0 8px;
  vertical-align: middle;
}

.ant-divider {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  background: #e8e8e8;
}

.line_11 {
  color: rgb(18, 144, 201);
  text-decoration: underline;
  cursor: pointer;
}

.back {
  background-color: #f1f3f4;
}

.trade-details-modal tr {
  border: 1px solid #ddd;
  border-right: none;
  border-left: none;
}

.companyimg {
  float: left;
  width: 36px;
  height: 26px;
  flex: none;
  margin-right: 4px;
  box-shadow: 0px 1px 2px 0px rgb(0 0 0 / 20%);
}

.left_menu {
  background-color: #fff;
  max-height: 95%;
  overflow-y: auto;
  height: auto;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  width: 350px;
}

.hidemenu {
  display: block;
  width: 0em;
  padding-left: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  padding-right: 0em;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.udb507 {
  width: calc(100% - 360px);
  display: flex;
  height: 100%;
  box-sizing: border-box;
  flex-direction: column;
  padding-left: 0em;
  margin-left: 10px;
}

.udb507two {
  width: 100% !important;
}

.left_menu_context-title {
  font-size: 18px;
  color: #1a2332;
  font-family: "Arial Bold";
  margin-bottom: 10px;
  position: relative;
}

.Clear_all {
  position: absolute;
  right: 0px;
  font-size: 16px;
  z-index: 999;
  cursor: pointer;
}

.left_menu_context {
  margin-bottom: 30px;
}
.trade_date_picker,
.left_menu_context /deep/ .el-input__inner {
  height: 36px !important;
  font-size: 16px;
}

.el-range-editor.el-input__inner {
  padding: 0px !important;
}

/deep/ .el-radio {
  justify-content: flex-start;
  font-size: 1.1428575rem !important;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #009ea7;
  font-size: 1.1428575rem !important;
}

/deep/ .el-radio__label {
  font-size: 1.1428575rem !important;
  color: #1a2332;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #009ea7;
  background: #fff;
}

/deep/ .el-radio__input.is-checked .el-radio__inner::after {
  background: #009ea7;
}

.SactionIcon {
  position: relative;
  top: 0.3rem;
  left: 1rem;
}

.dadePickerBorder {
  border-radius: 7px;
  border: 1px solid #cccccc;
}

.products-Shipping-table {
  width: 13.5714rem;
  background: #f2f5f9;
  font-family: "Arial Bold";
  height: 3.57142857rem;
  line-height: 3.57142857rem;
  display: inline-block;
}

.products-Shipping-table-text {
  padding-left: 1.4285714rem;
  width: 13.5714rem;
}

.products-Shipping-item {
  font-size: 18px;
  color: #1a2332;
  width: 48%;
  border-bottom: 1px solid #cccccc;
}

.products-Shipping-box {
}

/deep/ .el-select-dropdown {
  width: 100%;
}

.contry_img {
  width: 60px;
  height: 40px;
  margin-right: 5px;
}

.left_menu_padding {
  padding: 30px 20px;
}
.scrollbar_right {
  margin-left: 10px;
}
.contry_img {
  width: 60px;
  height: 40px;
  margin-right: 5px;
}
::v-deep.table_X tbody .el-table__row .el-table__cell {
  height: 60px !important;
  padding: 10px 0;
}
::v-deep.el-table .cell.el-tooltip {
  line-height: 40px;
}
.moreSaction{
  font-size:20px;
}
@media screen and (max-width: 1920px) {
  .udb507 {
    width: calc(100% - 270px);
  }
  .left_menu {
    width: 260px;
  }
  .left_menu_context-title {
    font-size: 14px;
    margin-bottom: 8px;
  }
  .Clear_all {
    font-size: 14px;
  }
  .operations-box-bottom /deep/ .el-table .cell {
    line-height: 27px;
    height: 30px;
  }
  .left_menu_context {
    margin-bottom: 22px;
  }
  .trade_date_picker,
  .left_menu_context /deep/ .el-input__inner {
    height: 32px !important;
    font-size: 14px;
  }

  .left_menu_padding {
    padding: 22px 15px;
  }
  .scrollbar_right {
    margin-left: 7px;
  }
  .contry_img {
    width: 45px;
    height: 30px;
    margin-right: 4px;
  }
  ::v-deep.table_X tbody .el-table__row .el-table__cell {
    height: 46px !important;
    padding: 8px 0;
  }
  ::v-deep.el-table .cell.el-tooltip {
    line-height: 30px;
  }
  .moreSaction{
    font-size:16px;
  }
}
@media screen and (max-width: 1439px) {
  .udb507 {
    width: calc(100% - 225px);
    margin-left: 6px;
  }
  .left_menu {
    width: 235px;
  }
  .left_menu_context-title {
    font-size: 12px;
    margin-bottom: 7px;
  }
  .operations-box-bottom /deep/ .el-table .cell {
    line-height: 24px;
    height: 28px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }

  .left_menu_padding {
    padding: 20px 12px;
  }
  .scrollbar_right {
    margin-left: 6px;
  }

  .contry_img {
    width: 40px;
    height: 26px;
    margin-right: 3px;
  }
  ::v-deep.table_X tbody .el-table__row .el-table__cell {
    height: 40px !important;
    padding: 7px 0;
  }
  ::v-deep.el-table .cell.el-tooltip {
    line-height: 26px;
  }
  .moreSaction{
    font-size:14px;
  }
}
</style>
